/* ============================================================
   Himedi Redesign — shared interactions (vanilla JS, no deps)
   Serves both the homepage and About page; every block feature-detects
   its target elements, so absent sections are simply skipped.
   Source: design-agent homepage-v19.html / about-v10.html
   ============================================================ */
(function(){
  "use strict";
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var clamp=function(v,a,b){return Math.max(a,Math.min(b,v));};
  // progressive-enhancement hook: reveal animations only run with JS on
  document.body.classList.add('js');

  // header solidify on scroll
  var hdr=$('#hdr');
  if(hdr){
    var onScroll=function(){ hdr.classList.toggle('solid', window.scrollY>40); };
    onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  }

  // drawer (focus-trapped, inert-aware)
  var burger=$('#burger'), drawer=$('#drawer'), scrim=$('#scrim'), dclose=$('#dclose'), lastF=null;
  function keyD(e){
    if(e.key==='Escape'){ closeD(); return; }
    if(e.key!=='Tab') return;
    var f=$$('a[href],button',drawer).filter(function(el){ return el.offsetParent!==null; });
    if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    else if(!drawer.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
  }
  function openD(){ lastF=document.activeElement; drawer.classList.add('open'); scrim.classList.add('open'); drawer.setAttribute('aria-hidden','false'); drawer.removeAttribute('inert'); burger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; dclose.focus(); document.addEventListener('keydown',keyD); }
  function closeD(){ drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('inert',''); burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; document.removeEventListener('keydown',keyD); if(lastF) lastF.focus(); }
  if(burger && drawer && scrim && dclose){
    burger.addEventListener('click',openD); dclose.addEventListener('click',closeD); scrim.addEventListener('click',closeD);
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',closeD); });
  }

  // reveal-on-scroll + how-it-works step activation
  if('IntersectionObserver' in window){
    var ro=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); ro.unobserve(e.target); } }); }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(function(el){ ro.observe(el); });
    var stepEls=$$('#steps .step');
    if(stepEls.length){
      var so=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('active'); }); }, {threshold:.5, rootMargin:'0px 0px -12% 0px'});
      stepEls.forEach(function(el){ so.observe(el); });
    }
  } else {
    $$('.reveal').forEach(function(el){ el.classList.add('in'); });
    $$('#steps .step').forEach(function(el){ el.classList.add('active'); });
  }

  // system explorer (tabs) + per-system background crossfade
  var tabs=$$('.systab'), bioBgs=$$('.bio .bg .bgimg');
  function hydrateBg(b){ if(b && b.dataset.src && !b.style.backgroundImage){ b.style.backgroundImage='url("'+b.dataset.src+'")'; } }
  if(bioBgs.length && 'IntersectionObserver' in window){
    var bio=$('.bio');
    var bo=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ bioBgs.forEach(hydrateBg); bo.disconnect(); } }, {rootMargin:'50% 0px'});
    if(bio) bo.observe(bio);
  } else { bioBgs.forEach(hydrateBg); }
  if(tabs.length){
    var selTab=function(t){
      tabs.forEach(function(x){ x.setAttribute('aria-selected', x===t?'true':'false'); x.tabIndex=(x===t?0:-1); var p=$('#'+x.getAttribute('aria-controls')); if(p) p.hidden=(x!==t); });
      var id=t.getAttribute('aria-controls');
      bioBgs.forEach(function(b){ if(b.dataset.sys===id) hydrateBg(b); b.classList.toggle('active', b.dataset.sys===id); });
    };
    tabs.forEach(function(t,i){
      t.addEventListener('click', function(){ selTab(t); });
      t.addEventListener('keydown', function(e){
        var n=null;
        if(e.key==='ArrowRight'||e.key==='ArrowDown') n=tabs[(i+1)%tabs.length];
        else if(e.key==='ArrowLeft'||e.key==='ArrowUp') n=tabs[(i-1+tabs.length)%tabs.length];
        if(n){ e.preventDefault(); n.focus(); selTab(n); }
      });
    });
  }

  // US / Korea functional slider
  var cmp=$('#cmp');
  if(cmp){
    var range=$('#cmpRange'), us=$('#cmpUS'), handle=$('#cmpHandle'), knob=$('#cmpKnob');
    var paneKR=$('#paneKR'), paneUS=$('#paneUS'), paneHint=$('#paneHint');
    var setPos=function(v){
      v=clamp(v,0,100); var p=v+'%';
      us.style.setProperty('--pos',p); handle.style.left=p; knob.style.left=p;
      range.value=v; range.setAttribute('aria-valuetext', Math.round(v)+'% annual physical, '+Math.round(100-v)+'% Korean checkup');
      var usO=clamp((v-55)/22,0,1);
      var krO=clamp((45-v)/22,0,1);
      paneUS.style.opacity=usO;
      paneKR.style.opacity=krO;
      paneHint.style.opacity=clamp(1-Math.max(usO,krO),0,1);
    };
    setPos(50);
    range.addEventListener('input', function(){ setPos(parseFloat(range.value)); });
    var stage=$('.cmp-stage',cmp), dragging=false;
    var fromEvent=function(e){ var r=stage.getBoundingClientRect(); var x=(e.touches?e.touches[0].clientX:e.clientX)-r.left; setPos(x/r.width*100); };
    knob.addEventListener('pointerdown',function(e){ dragging=true; fromEvent(e); if(knob.setPointerCapture) try{ knob.setPointerCapture(e.pointerId); }catch(_){} });
    stage.addEventListener('pointerdown',function(e){ if(e.target!==range){ dragging=true; fromEvent(e);} });
    window.addEventListener('pointermove',function(e){ if(dragging){ fromEvent(e); if(e.cancelable&&e.pointerType!=='mouse') e.preventDefault(); } },{passive:false});
    window.addEventListener('pointerup',function(){ dragging=false; });
    window.addEventListener('pointercancel',function(){ dragging=false; });
  }

  // outcomes carousel
  var car=$('#carousel');
  if(car){
    var track=$('#ctrack',car), slides=$$('.cslide',track), dotsWrap=$('#cdots',car);
    var i=0, n=slides.length;
    slides.forEach(function(s,idx){
      var d=document.createElement('button');
      d.className='cdot'; d.type='button';
      d.setAttribute('aria-label','Story '+(idx+1)+' of '+n);
      d.addEventListener('click', function(){ go(idx); });
      dotsWrap.appendChild(d);
    });
    var dots=$$('.cdot',dotsWrap);
    function go(x){
      i=(x+n)%n; track.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,k){ d.setAttribute('aria-current', k===i?'true':'false'); });
      slides.forEach(function(s,k){ s.setAttribute('aria-hidden', k===i?'false':'true'); if(k===i) s.removeAttribute('inert'); else s.setAttribute('inert',''); });
    }
    $('#cprev',car).addEventListener('click', function(){ go(i-1); });
    $('#cnext',car).addEventListener('click', function(){ go(i+1); });
    var sx=null;
    track.addEventListener('touchstart', function(e){ sx=e.touches[0].clientX; }, {passive:true});
    track.addEventListener('touchend', function(e){ if(sx===null) return; var dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>40){ go(i+(dx<0?1:-1)); } sx=null; }, {passive:true});
    go(0);
  }
})();
